// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconMute(Props) {
  var className = Props.className;
  var tmp = {
    height: "24",
    width: "31",
    fill: "none",
    viewBox: "0 0 31 24",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M2.75 0.65625L1.85938 0L0.5 1.73438L1.39062 2.4375L28.2031 23.2969L29.0938 23.9531L30.4531 22.1719L29.5625 21.5156L25.9531 18.7031C27.8281 17.0625 29 14.625 29 11.9531C29 9.04688 27.5469 6.42188 25.3906 4.78125L24.0312 6.5625C25.6719 7.82812 26.75 9.75 26.75 11.9531C26.75 14.1094 25.7188 16.0312 24.125 17.2969L18.5 12.8906V1.45312H16.25L10.4375 6.60938L2.75 0.65625ZM3.5 7.45312V16.4531H9.5L16.25 22.4531H18.5V18.6562L4.29688 7.45312H3.5ZM22.6719 15.5625C23.75 14.7656 24.5 13.4531 24.5 11.9531C24.5 10.5 23.75 9.1875 22.6719 8.39062L21.3125 10.1719C21.875 10.5938 22.25 11.25 22.25 11.9531C22.25 12.7031 21.875 13.3594 21.3125 13.7812L22.6719 15.5625Z",
    fill: "currentColor"
  }));
}
IconMute.displayName = "IconMute";
var make = IconMute;
export { make };
/* react Not a pure module */